import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { StandardDialog } from '@roc/ui';
import { PricingEconomicsStepper } from './pricingEconomicsStepper';
import { CompanyProfileStore } from '../../stores/companyProfileStore';
import { SearchBorrowersForPricingEconomicsTier } from './searchBorrowersForPricingEconomicsTier';
import PricingEconomicsDefaultFees from './pricingEconomicsDefaultFees';

export type AddPricingEconomicsTierDialogProps = {
  open: boolean;
  handleClose: () => void;
  title: string;
  companyProfileStore: CompanyProfileStore
};

export const EditBorrowersFromTierDialog = observer((props: AddPricingEconomicsTierDialogProps) => {
  const { open, handleClose, title, companyProfileStore } = props;
  const { lenderTermTierEconomicsFormStore } = companyProfileStore

  const stepsLabels = ['Select Borrower(s) for Economics']
  const stepsContent = [<SearchBorrowersForPricingEconomicsTier companyProfileStore={companyProfileStore} />]

  const onSave = () => {
    lenderTermTierEconomicsFormStore.addRemoveBorrowerFromTier()
    handleClose()
  }

  return (
    <StandardDialog
      maxWidth={'md'}
      open={open}
      title={title}
      handleClose={handleClose}
      dialogContent={
        <>
          <PricingEconomicsStepper skipStepValidation={true} onSave={onSave} stepsLabel={stepsLabels} stepsContent={stepsContent} companyProfileStore={companyProfileStore} />
        </>
      }
    />
  );
});

export default EditBorrowersFromTierDialog;
